export const initialColorMode = {
	initialColorMode: 'system',
	useSystemColorMode: false
};
